import { render, staticRenderFns } from "./FAQiOS530.vue?vue&type=template&id=6052b3ae&scoped=true"
import script from "./FAQiOS530.vue?vue&type=script&lang=js"
export * from "./FAQiOS530.vue?vue&type=script&lang=js"
import style0 from "./FAQiOS530.vue?vue&type=style&index=0&id=6052b3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052b3ae",
  null
  
)

export default component.exports